import { parse } from 'query-string';

const retrieveSerialFromQueryString = (): null | string => {
  const { serialKey: serial = null } = parse(window.location.search);
  if (Array.isArray(serial)) return null;
  return serial;
};

export { retrieveSerialFromQueryString };
